import {FC} from "react";

const LocationIcon: FC<{color?: string; size?: number; style?: any}> = (props: any) => {
    return <svg
        style={{...props.style}}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill={props.color ?? "inherit"}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.93 11H21.5C21.7761 11 22 11.2239 22 11.5V12.5C22 12.7761 21.7761 13 21.5 13H19.93C19.4709 16.6202 16.6202 19.4709 13 19.93V21.5C13 21.7761 12.7761 22 12.5 22H11.5C11.2239 22 11 21.7761 11 21.5V19.93C7.37981 19.4709 4.52909 16.6202 4.07 13H2.5C2.22386 13 2 12.7761 2 12.5V11.5C2 11.2239 2.22386 11 2.5 11H4.07C4.52909 7.37981 7.37981 4.52909 11 4.07V2.5C11 2.22386 11.2239 2 11.5 2H12.5C12.7761 2 13 2.22386 13 2.5V4.07C16.6202 4.52909 19.4709 7.37981 19.93 11ZM6 12C6 15.3137 8.68629 18 12 18C13.5913 18 15.1174 17.3679 16.2426 16.2426C17.3679 15.1174 18 13.5913 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12Z"            fill={props.color ?? 'inherit'}
        />
    </svg>
}

export default LocationIcon
